import type { NavigateFunction } from "react-router";

let navigator: NavigateFunction | null = null;

export const setNavigator = (nav: NavigateFunction) => {
    navigator = nav;
};

export const navigate = (
    to: string,
    options?: { replace?: boolean; state?: any }
) => {
    if (navigator) {
        navigator(to, options);
    } else {
        window.location.href = to;
    }
};

export const redirectToError502 = () => {
    if (window.location.pathname !== "/502") {
        navigate("/502", { replace: true });
    }
};